// extracted by mini-css-extract-plugin
module.exports = {"moreInfo":"qz","link":"qA","linkText":"qB","linkIcon":"qC","isRental":"qD","active":"qE","synopsisAndButton":"qF","linkWrapper":"qG"};